type StorytellingSlotConfig = {
    moduleIndex: number;
    isAlternate: boolean;
};

export const getStorytellingModulesConfig = (
    itemsPerRow: 3 | 5,
    moduleCount: number,
    itemCount?: number
): Record<number, StorytellingSlotConfig> => {
    const everyTwoRows = itemsPerRow * 2;
    const config: Record<number, StorytellingSlotConfig> = {};

    for (let i = 0; i < moduleCount; i++) {
        let slot = i * everyTwoRows;
        // Slots at itemCount render after the last item. Page-local indices never
        // reach i * everyTwoRows when that value is beyond the current page.
        if (itemCount !== undefined && slot > itemCount) {
            slot = itemCount;
        }
        if (config[slot]) {
            continue;
        }
        config[slot] = {
            moduleIndex: i,
            isAlternate: i % 2 === 1,
        };
    }

    return config;
};
